// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"54902543","203":"32f17a18","848":"9d62948b"}[chunkId] + ".chunk.css";
};